import { styled } from 'styled-components';
import { COLORS } from '@ydistri/theme';

const ActualDataWrapper = styled.div`
  display: inline-block;
  color: ${COLORS.PRIMARY};
`;

export default ActualDataWrapper;
